import { render, staticRenderFns } from "./PageSubnav.vue?vue&type=template&id=364a2cdc&"
import script from "./PageSubnav.vue?vue&type=script&lang=js&"
export * from "./PageSubnav.vue?vue&type=script&lang=js&"
import style0 from "./PageSubnav.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports